import type { MailboxInfo } from 'owa-client-types';
import { mutatorAction } from 'satcheljs';
import { getIndexerValueForMailboxInfo } from 'owa-client-types';
import { getSelectedCalendarsStore } from '../store/store';
import { dedupeArrayValues } from 'owa-selected-calendars-utils';
import { getSelectedCalendarsForUser } from '../selectors/getSelectedCalendarsForUser';
import { convertIdsToTargetFormat, ConvertIdSource } from 'owa-immutable-id';
import { getTargetFormat } from 'owa-immutable-id-store';
import { updateSelectedCalendars, refreshImmutableSelectedCalendars } from './publicActions';

export const updateSelectedCalendarsInStore = mutatorAction(
    'UPDATE_SELECTED_CALENDARS_IN_STORE',
    (calendarIds: string[], mailboxInfo: MailboxInfo) => {
        const key = getIndexerValueForMailboxInfo(mailboxInfo);
        getSelectedCalendarsStore().selectedCalendars.set(key, dedupeArrayValues(calendarIds));
    }
);

export const addSelectedCalendarInStore = mutatorAction(
    'ADD_SELECTED_CALENDAR_IN_STORE',
    (calendarId: string, mailboxInfo: MailboxInfo) => {
        const key = getIndexerValueForMailboxInfo(mailboxInfo);
        getSelectedCalendarsStore().selectedCalendars.set(
            key,
            dedupeArrayValues([...getSelectedCalendarsForUser(mailboxInfo), calendarId])
        );
    }
);

export const formatInitialSelectedCalendars = async (ids: string[], mailboxInfo: MailboxInfo) => {
    const formattedResult = await convertIdsToTargetFormat(
        ids,
        getTargetFormat(mailboxInfo),
        mailboxInfo.userIdentity,
        ConvertIdSource.SelectedCalendars,
        mailboxInfo
    );

    updateSelectedCalendars(formattedResult, mailboxInfo);
    refreshImmutableSelectedCalendars(mailboxInfo);
};
